import React from 'react';
import {
    IonModal,
    IonContent,
    IonButton,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonIcon, useIonAlert, IonFooter,
} from '@ionic/react';
import {
    arrowBack,
} from 'ionicons/icons';
import MatrimonyProfileDetails from "./MatrimonyProfileDetails";
import useStore from "../zustand/useStore";
import {
    actionToApplyForMatrimonialProfilePost,
    actionToDeleteJobPortalJobPost
} from "../apiHelpers/CommonAction";

export default function MatrimonialDetailSheetPopup({ isOpen, onDidDismiss,matrimonialProfileDetail,isMobile }) {
    const {userAuthDetail,userMatrimonialProfileData} = useStore();
    const matrimonialProfileData = userMatrimonialProfileData?.matrimonialProfileData?.[0]
    const {userInfo} = userAuthDetail;
    const [presentAlert] = useIonAlert();

    const callFunctionToDeletePost = (id)=>{
        presentAlert({
            header: 'Are you sure?',
            cssClass: 'custom_site_alert_toast',
            message: 'You want to delete this job.',
            buttons: [
                {text: 'Cancel', role: 'cancel'},
                {text: 'Delete', role: 'confirm', handler: async () =>{
                        await actionToDeleteJobPortalJobPost(id)
                        onDidDismiss();
                    }},
            ],
        });
    }

    const openMatrimonialInterestMail = async (data) => {
        let interestedMembers = [];
        if (data?.interested_member_id_array) {
            interestedMembers = JSON.parse(data.interested_member_id_array);
        }

        if (!interestedMembers?.includes(userInfo?.id)) {
            interestedMembers.push(userInfo?.id);
            let template = await actionToApplyForMatrimonialProfilePost(
                data?.id,
                JSON.stringify(interestedMembers)
            );

            const subject = encodeURIComponent("Matrimonial Interest - Suitable Match");
            let body = encodeURIComponent(
                `Hello,\n\nI am interested in this matrimonial profile.\n\nThanks,\n${userInfo?.name || ''}`
            );

            if (template) {
                let filledTemplate = template
                    .replace(/{PROFILE_URL}/g, matrimonialProfileData?.pdf_url || "")
                    .replace(/{NAME}/g, matrimonialProfileData?.name || "")
                    .replace(/{MOBILE}/g, matrimonialProfileData?.phone || "")
                    .replace(/{EMAIL}/g, matrimonialProfileData?.email || "");

                body = encodeURIComponent(filledTemplate);
            }

            window.location.href = `mailto:${data?.email}?subject=${subject}&body=${body}`;
        }
    };


    const contactMatrimonialProfile = (data)=>{
        if(matrimonialProfileData?.id) {
            presentAlert({
                header: 'Are you sure?',
                cssClass: 'custom_site_alert_toast',
                message: 'You want to show interest this profile.',
                buttons: [
                    {text: 'Cancel', role: 'cancel'},
                    {text: 'Apply', role: 'confirm', handler: () => openMatrimonialInterestMail(data)},
                ],
            });
        }
    }


    return (
        <IonModal
            isOpen={isOpen}
            onDidDismiss={onDidDismiss}
            initialBreakpoint={1}
            breakpoints={[0, 1]}
            handleBehavior="cycle"
            data-publisher-content="true"
        >
            {(matrimonialProfileDetail?.id) ?
                <>
                    <IonHeader className="job_detail_sheet_header sheet_modal_header">
                        <IonToolbar>
                            <IonButtons slot="start">
                                <IonButton className={"close_job_post_button"} onClick={onDidDismiss}>
                                    <IonIcon icon={arrowBack}/>
                                </IonButton>
                            </IonButtons>
                            <div className="job_detail_sheet_header_text">
                                <div className="job-basic-info-image">
                                    <span className="job-basic-info-text">{matrimonialProfileDetail.name}</span>
                                </div>
                            </div>
                            <IonButtons slot="end">
                                {(matrimonialProfileDetail?.applied_member_id_array && JSON.parse(matrimonialProfileDetail?.applied_member_id_array).includes(userInfo?.id)) ?
                                    <div className="filter_sheet_clear_all_btn">
                                        Contacted
                                    </div>
                                    :
                                    <div onClick={() => contactMatrimonialProfile(matrimonialProfileDetail)} className="filter_sheet_clear_all_btn">
                                        Contact
                                    </div>
                                }
                                {(userInfo?.id === matrimonialProfileDetail?.created_by && userInfo?.role === 1) &&
                                    <div onClick={()=>callFunctionToDeletePost(matrimonialProfileDetail?.id)} className="filter_sheet_clear_all_btn">
                                        Delete
                                    </div>
                                }
                            </IonButtons>
                        </IonToolbar>
                    </IonHeader>
                    <IonContent className="ion-padding job_detail_sheet_content">
                        <MatrimonyProfileDetails matrimonialProfileDetail={matrimonialProfileDetail}/>
                    </IonContent>
                    {(isMobile) ?
                        <IonFooter className={"blank_footer_bar"}>
                            <IonToolbar>
                                <div id={'web-ad-banner-bottom'} className={"add_in_main_news_page_appear_here"}>
                                    <div>
                                        Google ads will appear here
                                    </div>
                                </div>
                            </IonToolbar>
                        </IonFooter>
                        :''
                    }
                </>:''
            }
        </IonModal>
    );
}
